import { render, staticRenderFns } from "./FrundDetails.vue?vue&type=template&id=ab860600&"
import script from "./FrundDetails.vue?vue&type=script&lang=js&"
export * from "./FrundDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports